import React from "react";
import styled from "styled-components";
import g from "../../assets/Rectangle 195@2x.png";

export const BackgroundImageDisplayer = styled.div`
  width: 100%;
  height: 100%;

  /* background-position: 37% -1%;
  background-size: 105% 110%; */
  background-image: url(${g});
`;

export const BGImageOnlyCon = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  img {
    pointer-events: none;
    user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    object-fit: ${(props) => (props.objectfit ? props.objectfit : "cover")};
    width: 100%;
    height: ${(props) => (props.height ? props.height : "100%")};
    object-position: ${(props) => props.objpos && props.objpos};
  }
`;

const BGImageDisplay = ({ bgimage, options, objectfit }) => {
  console.log(options);

  const returnOptions = (options) => {
    if (!options) return { objpos: "", offset: "", height: "" };
    else {
      let { objpos = "", offset = "", height = "" } = options;
      return { objpos, offset, height };
    }
  };

  let { objpos, offset, height } = returnOptions(options);
  console.log(objpos, offset);

  return (
    <BGImageOnlyCon
      height={height}
      objectfit={objectfit}
      objpos={objpos}
      offset={offset}
      onDragStart={() => false}
      draggable={false}
      onClick={(e) => e.preventDefault()}
    >
      <img
        alt="background"
        onDragStart={() => false}
        draggable={false}
        onClick={(e) => e.preventDefault()}
        className="bg"
        src={bgimage}
      />
    </BGImageOnlyCon>
  );
};

export default BGImageDisplay;
